import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const fieldworkRoutes: Route = {
    path: 'fieldwork',
    data: { title: 'fieldwork' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'fieldwork-project' },
        {
            path: 'fieldwork-project',
            loadComponent: () =>
                import('./fieldwork-project/fieldwork-project.component').then((m) => m.FieldworkProjectComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'fieldwork-project' },
        },
        {
            path: 'fieldwork-entry',
            loadComponent: () =>
                import('./fieldwork-entry/fieldwork-entry.component').then((m) => m.FieldworkEntryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'fieldwork-entry' },
        },
        {
            path: 'fieldwork-note',
            loadComponent: () =>
                import('./fieldwork-note/fieldwork-note.component').then((m) => m.FieldworkNoteComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'fieldwork-note' },
        },
    ],
};
